import { Box } from "@chakra-ui/react";

import type { TSelectOptionType } from "@components/Select/types";

import type { TAddressBookEntry } from "../types";
import getAddressTitle from "./getAddressTitle";

const mapAddressItemsToSelectOptions = (
  addressItems: TAddressBookEntry[],
  type: "locker" | "address"
): TSelectOptionType[] =>
  addressItems.map((addressItem) => {
    const displayLabel = (
      <Box>
        <Box>{addressItem.contactName}</Box>
        <Box sx={{ fontSize: "0.75rem" }}>{getAddressTitle(addressItem, type)}</Box>
      </Box>
    );
    return { label: addressItem.contactName || "", displayLabel, value: addressItem.id };
  });

export default mapAddressItemsToSelectOptions;
